type Provider<T> = () => T
type InflightPromiseMap = Map<string, Promise<object | undefined>>
type PromiseProvider = Provider<Promise<object | undefined>>
type PromiseProviderMap = Map<string, PromiseProvider>

export class InflightPromise {
  private inflightPromises: InflightPromiseMap = new Map<
    string,
    Promise<object | undefined>
  >()

  private promiseProviders: PromiseProviderMap = new Map<
    string,
    Provider<Promise<object | undefined>>
  >()

  public registerProvider(key: string, provider: PromiseProvider): void {
    this.promiseProviders.set(key, provider)
  }

  public isProviderRegistered(key: string): boolean {
    return this.promiseProviders.has(key)
  }

  public unwrap<T>(key: string): Promise<T> {
    const inflightPromise = this.inflightPromises.get(key)

    if (inflightPromise) {
      return inflightPromise as Promise<T>
    }

    const promiseProvider = this.promiseProviders.get(key)

    if (!promiseProvider) {
      throw new Error(`Promise provider not registered for key ${key}`)
    }

    const promise = promiseProvider().finally(() => {
      this.inflightPromises.delete(key)
    })

    this.inflightPromises.set(key, promise)
    return promise as Promise<T>
  }
}
